<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn collapse-btn2" @click="collapseChage">
      <!-- <i class="el-icon-menu el-icon-menu-position"></i> -->
      <img class="header-logo" src="../../../../static/images/home/mc.png" style="width: 88%;margin-left: 0px;"/>
      <!--系统名称图片形式-->
      <!--<img style="margin-top:5px; width:90%; height:90%" src="../../../../static/images/home/pic_titile.png" />-->
    </div>
    <!-- <span class="header-title">&nbsp;&nbsp;中国消防协会会员管理系统</span> -->

    <!-- <div class="logo">中国消防协会综合办公系统</div> -->
    <!-- 隐藏菜单收缩图标，修改为协会会徽进行菜单拉伸 by li.xue 2019/7/11 start
    <div class="collapse-btn" @click="collapseChage">
      <i class="el-icon-menu el-icon-menu-position"></i>
    </div>
    end by li.xue -->
    <div class="header-right">
      <div class="header-user-con">
        <div v-if="isDp" style="cursor: pointer;" @click="xtrkClick()">
          <el-tooltip effect="dark" :content="'数据展示'" placement="bottom">
            <img style="width: 16px;height: 16px;margin-right: 5px;" src="../../../../static/images/home/icn_pm.png"/>
          </el-tooltip>


        </div>
        <!-- 全屏显示 -->
        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen?`取消全屏`:`全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="dropdown-position" @command="handleCommand">
          <div class="el-dropdown-link">
            <span id="realname">{{realname}}</span>
            [
            <span id="organizationName">{{organizaitonName}}</span>
            ]
            <i class="el-icon-arrow-down el-icon--right"></i>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="personalFlag" command="personal" class="iconfont icon-personal iconfontDrop">
              &nbsp;
              <span v-if="usertype == 'ENG'">User Center</span>
              <span v-else>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item command="logout" class="iconfont icon-logout iconfontDrop">
              &nbsp;
              <span v-if="usertype == 'ENG'">Log Out</span>
              <span v-else>退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

      </div>
    </div>
    <el-dialog :title="DialogTitle" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
      <el-form id="userForm" ref="userForm" :model="userForm" :label-width="labelWidth" :label-position="'left'" :rules="userInforRules">
        <el-row class="mb5">
          <el-col :span="21">
            <el-form-item prop="username" :label="usernameLabel" class="is-required">
              <el-input size="small" v-model="userForm.username" :placeholder="usernameLabel" :disabled="!userForm.usernameFlag" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <!--
          <el-col :span="2">
            <el-button v-text="userForm.usernameText" type="text" @click="changeUsername()"></el-button>
          </el-col>
          -->
        </el-row>
        <el-row class="mb5" v-show="userForm.usernameFlag">
          <el-col :span="21">
            <el-form-item prop="messageCode" :label="messageCodeLabel" class="is-required">
              <el-input size="small" v-model="userForm.messageCode" :placeholder="messageCodeLabel" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row class="mb5">
          <el-col :span="21">
            <el-form-item prop="password" :label="passwordLabel" class="is-required">
              <el-input type="password" size="small" v-model="userForm.password" :placeholder="passwordLabel" :disabled="!userForm.passwordFlag" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="2">
            <el-button v-text="userForm.passwordText" type="text" @click="changePassword()"></el-button>
          </el-col>
        </el-row>
        <el-row class="mb5" v-show="userForm.passwordFlag">
          <el-col :span="21">
            <el-form-item prop="passwordAgain" :label="checkPassLabel" class="is-required">
              <el-input type="password" size="small" v-model="userForm.passwordAgain" :placeholder="checkPassLabel" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="text-align: center;" v-show="userForm.passwordFlag">
          <el-button size="small" type="clear" icon="el-icon-close" @click="dialogVisible = false">
            <span v-if="usertype=='ENG'">cancel</span>
            <span v-else>取消</span>
          </el-button>
          <el-button size="small" type="success" icon="el-icon-check" @click="confirm()">
            <span v-if="usertype=='ENG'">confirm</span>
            <span v-else>确定</span>
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <div id="some-div" style="display:none;"></div>
  </div>
</template>
<script>
import bus from "../../../common/js/bus";
import { mapMutations } from "vuex";
var officeHandshake = null;
export default {
  data() {
    return {
      collapse: true,
      fullscreen: false,
      currentUser: this.CONSTANT.currentUser,
      realname: null,
      organizationName: null,
      //个人中心的Dialog显示与隐藏
      dialogVisible: false,
      //个人中心DropDown显示与隐藏
      personalFlag: false,
      //用户类型，中文还是英文
      usertype: "CHN",
      //DialogTitle
      DialogTitle: "个人中心",
      usernameLabel: "用户名",
      messageCodeLabel: "验证码",
      passwordLabel: "密码",
      checkPassLabel: "确认密码",
      labelWidth: "80px",
      //修改用户名密码的Form表单
      userForm: {
        usernameWord: "", //保存原用户名
        passwordWord: "", //仅用于显示
        userid: "",
        username: "",
        password: "admin123",
        passwordAgain: "admin123",
        messageCode: "",
        messageCodeReal: "",
        messageCodeText: "获取验证码",
        messageBtnFlag: false,
        //修改按钮文字
        usernameText: "修改",
        passwordText: "修改",
        //修改框标识位
        usernameFlag: false,
        passwordFlag: false
      },
      time: 60,
      timer: "",
      isDp:false,
      //Form表单的Rules
      userInforRules: {
        /*个人用心不允许修改用户名，不用进行用户名校验 by li.xue 2020/5/27
        username: [
          {
            validator: (rule, value, callback) => {
              if (value == null || value == "") {
                callback(
                  new Error(
                    this.usertype == "ENG"
                      ? "Please input a email."
                      : "请输入手机号"
                  )
                );
              } else {
                if (this.usertype == "ENG") {
                  if (
                    /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@[0-9A-Za-z]+(?:\.[0-9A-Za-z]+)+$/.test(
                      value
                    ) == false
                  ) {
                    callback(new Error("The email format is not correct."));
                  } else {
                    callback();
                  }
                } else {
                  if (/^[1][3,4,5,7,8][0-9]{9}$/.test(value) == false) {
                    callback(new Error("手机号格式不正确"));
                  } else {
                    callback();
                  }
                }
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        */
        messageCode: [
          {
            validator: (rule, value, callback) => {
              if (!this.userForm.usernameFlag) {
                callback();
              } else {
                if (value == null || value == "") {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "Please input the verification code."
                        : "请输入验证码"
                    )
                  );
                } else if (value !== this.userForm.messageCodeReal) {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "The verification code is error."
                        : "验证码输入错误"
                    )
                  );
                } else {
                  callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        password: [
          {
            validator: (rule, value, callback) => {
              if (!this.userForm.passwordFlag) {
                callback();
              } else {
                if (value == null || value == "") {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "Please input a password."
                        : "请输入密码"
                    )
                  );
                } else if (
                //  /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value) ==
                  /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/.test(value) ==
                  false
                ) {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "Password must be 8-30-bit alphanumeric combination and include numbers, letters and special characters."
                        : "密码应为8-30位字母、数字、特殊字符组合"
                    )
                  );
                } else {
                  callback();
                }
              }
            },
            trigger: "blur"
          }
        ],
        passwordAgain: [
          {
            validator: (rule, value, callback) => {
              if (!this.userForm.passwordFlag) {
                callback();
              } else {
                if (value == null || value == "") {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "Please input the password again."
                        : "请再次输入密码"
                    )
                  );
                } else if (
                //  /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/.test(value) ==
                  /(?=.*[0-9])(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,30}/.test(value) ==
                  false
                ) {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "Password must be 8-30-bit alphanumeric combination and include numbers, letters and special characters."
                        : "密码应为8-30位字母、数字、特殊字符组合"
                    )
                  );
                } else if (value !== this.userForm.password) {
                  callback(
                    new Error(
                      this.usertype == "ENG"
                        ? "The two entries do not match."
                        : "两次输入密码不一致"
                    )
                  );
                } else {
                  callback();
                }
              }
            },
            trigger: "blur"
          }
        ]
      }
    };
  },
  created() {
    //fontSize恢复成初始大小，避免影响内部菜单 add by yushch 20191227
    let htmlDom = document.getElementsByTagName('html')[0];
    htmlDom.style.fontSize = '16px';
    //end add

    let vm = this;
    if (vm.currentUser != null) {
      vm.usertype = this.currentUser.usertype;
      vm.realname = this.currentUser.usertype!=null ? this.currentUser.username : this.currentUser.realname;
      vm.organizaitonName = this.currentUser.organizationVO.jgjc;
      vm.personalFlag = true;
      vm.userForm.userid = vm.currentUser.userid;
      vm.userForm.usernameWord = vm.currentUser.username;
      vm.userForm.passwordWord = "admin123";
    }
    //显示中文还是英文
    if(this.CONSTANT.currentUser.deptid != null && (this.CONSTANT.currentUser.deptid == '3' || this.CONSTANT.currentUser.deptid == '4' || this.CONSTANT.currentUser.deptid == '5' || this.CONSTANT.currentUser.deptid == '99')){
      this.isDp = true
    }
    this.showCHNorENG();
  },
  methods: {
    ...mapMutations(["SET_THEMEINFO"]),
    changeTheme(value) {
      this.SET_THEMEINFO(value);
    },
    xtrkClick:function(){
      if(this.CONSTANT.currentUser.deptid != null && (this.CONSTANT.currentUser.deptid == '3' || this.CONSTANT.currentUser.deptid == '4' || this.CONSTANT.currentUser.deptid == '5' || this.CONSTANT.currentUser.deptid == '99')){
      this.$router.push({ path: '/homeBig' });
      }
    },
    //显示中文还是英文
    showCHNorENG() {
      let vm = this;
      if (vm.usertype == "ENG") {
        vm.DialogTitle = "Personal Center";
        vm.usernameLabel = "username";
        vm.messageCodeLabel = "validate code";
        vm.passwordLabel = "password";
        vm.checkPassLabel = "confirm password";
        vm.labelWidth = "150px";
      } else {
        vm.DialogTitle = "个人中心";
        vm.usernameLabel = "用户名";
        vm.messageCodeLabel = "验证码";
        vm.passwordLabel = "密码";
        vm.checkPassLabel = "确认密码";
        vm.labelWidth = "80px";
      }
    },

    //用户名下拉菜单选择事件
    handleCommand(command) {
      if ("personal" == command) {
        this.personal();
      } else if ("logout" == command) {
        this.logout();
      }
    },
    //退出
    logout() {
      let vm = this;
      vm.$confirm('是否退出', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(() => {
          vm.logoutClick();
        }).catch(() => {
      });
    },
    //初始化通信组件
    initPostmate() {
    	if(officeHandshake) {
    		officeHandshake.destroy();
    		officeHandshake = null;
    	}
    	const me = this;
      let url = window.config.portalUrl + "#/loginNoPage"
    	const postmate = new Postmate({
    		container: document.getElementById("some-div"),
    		url: url
    	});
    	postmate.then(handshake => {
    		officeHandshake = handshake;
    		//绑定事件
    		handshake.on("tologin", me.tologin.bind(me));
    	});
    },
    tologin:function() {
      this.$router.push({ name: "login" });
    },
    //退出方法后台交互
    logoutClick: function(){

      let vm = this;
      vm.$axios.get("/logout").then(function(res) {
        if ((res.data.code = "00000000")) {
            localStorage.removeItem("isLogin");
            localStorage.removeItem("XTOKEN");
            localStorage.removeItem("CURRENTUSER");

            //登出门户
            if(officeHandshake){
              let data = {}
              vm.$parent.$parent.$parent.closeTip()
              console.log(vm.$parent.$parent.$parent.searchVal.showView+"~~~~~~~~~")
              officeHandshake.call("loginout", data);
            }else{
              //通信门户失败直接跳转
               vm.$parent.$parent.$parent.closeTip()
               console.log(vm.$parent.$parent.$parent.searchVal.showView+"~~~~~~~~~")
              vm.$router.push({ name: "login" });
            }


          }
        }.bind(this),function(error) {
          console.log(error);
        }
      );
    },

    //个人中心Click
    personalClick: function(){
      this.$router.push({path: '/personal/message'});
    },
    //个人中心
    personal: function() {
      this.dialogVisible = true;
      this.userForm.usernameFlag = false;
      this.userForm.passwordFlag = false;
      this.timer = null;
      this.userForm.messageBtnFlag = false;
      if (this.usertype == "ENG") {
        this.userForm.usernameText = "edit";
        this.userForm.passwordText = "edit";
        this.userForm.messageCodeText = "Get Verification Code";
      } else {
        this.userForm.usernameText = "修改";
        this.userForm.passwordText = "修改";
        this.userForm.messageCodeText = "获取验证码";
      }
      this.$nextTick(() => {
        this.$refs.userForm.resetFields();
      });

      this.userForm.username = this.userForm.usernameWord;
      this.userForm.password = this.userForm.passwordWord;
    },

    //修改用户名
    changeUsername: function() {
      if (this.userForm.usernameFlag == false) {
        this.userForm.usernameFlag = true;
        this.userForm.usernameText = this.usertype == "ENG" ? "cancel" : "取消";
      } else if (this.userForm.usernameFlag == true) {
        this.userForm.usernameFlag = false;
        this.userForm.usernameText = this.usertype == "ENG" ? "edit" : "修改";
        this.userForm.username = this.userForm.usernameWord;
      }
    },
    //修改密码
    changePassword: function() {
      if (this.userForm.passwordFlag == false) {
        this.userForm.passwordFlag = true;
        this.userForm.passwordText = this.usertype == "ENG" ? "cancel" : "取消";
        this.userForm.password = "";
        this.userForm.passwordAgain = "";
      } else if (this.userForm.passwordFlag == true) {
        this.userForm.passwordFlag = false;
        this.userForm.passwordText = this.usertype == "ENG" ? "edit" : "修改";
        this.userForm.password = this.userForm.passwordWord;
      }
    },
    //Dialog中的确定按钮
    confirm: function() {
      let vm = this;
      if (!this.userForm.usernameFlag && !this.userForm.passwordFlag) {
        this.$message({
          showClose: true,
          message:
            this.usertype == "ENG"
              ? "The username and password did not change."
              : "用户名密码未变化",
          type: "warning"
        });
        return;
      }
      this.$refs["userForm"].validate(valid => {
        if (valid) {
          var params = {
            userid: this.userForm.userid
          };
          if (vm.userForm.usernameFlag) {
            params.username = vm.userForm.username;
          }
          if (vm.userForm.passwordFlag) {
            params.password = vm.userForm.password;
          }
          //修改人、修改时间
          params.alterId = vm.currentUser.userid;
          params.alterName = vm.userForm.username;
          vm.$axios.post("/account/updateByVO", params).then(
            function(res) {
              var result = res.data.result;
              if (result == 1) {
                vm.$message({
                  message:
                    this.usertype == "ENG"
                      ? "Modify success, log out after 3 seconds."
                      : "修改成功，3秒后退出登录",
                  duration: 2000,
                  type: "success"
                });
                var count = 3;
                var timer2 = setInterval(() => {
                  if (count == 0) {
                    clearInterval(timer2);
                    this.logoutClick();
                  } else {
                    count--;
                  }
                }, 1000);
              } else {
                this.$message({
                  message:
                    this.usertype == "ENG"
                      ? "Modify the failure, please try again."
                      : "修改失败，请重试",
                  type: "error"
                });
              }
            }.bind(this),
            function(error) {
              console.log(error);
            }
          );
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit("collapse", this.collapse);
      /** 审核提示信息黄色、红色、绿色按钮长度控制 by li.xue 2020/6/2
      var e = document.getElementsByClassName("topScroll");
      if (e.length > 0) {
        if (this.collapse == false) {
          e[0].style.width = "calc(100% - 300px)";
        } else {
          e[0].style.width = "calc(100% - 130px)";
        }
      }
       */
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    }
  },
  mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
    this.initPostmate()
  }
};
</script>
<style scoped lang="scss">
/* .logo-title {
      background: url(/static/images/login/pic_logo.png)no-repeat center center; background-size: auto 100%; position: relative;
      width: 30px;
      height: 40px;
    } */
@import "../../../common/scss/mixin.scss";
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: 0 8px;
  font-size: 22px;
  color: #fff;
  background-image: url('/static/images/login/head_bg.jpg');
  @include bg-image($color-theme);
  background-repeat:repeat;
  background-size: 100% 100%;
}
.header-logo {
  margin-left: -50px;
  margin-top: 5px;
  width: 60%;
  height: 60%;
}

.collapse-btn {
  float: left;
  padding: 0 3px;
  cursor: pointer;
  line-height: 60px;
  margin-left: -15px;
}
.collapse-btn2 {
  line-height: 30px;
}

.el-icon-menu-position {
  margin-left: -4px;
}

.header .logo {
  /* background: url(/static/images/login/pic_logo.png)no-repeat center center; background-size: auto 100%; position: relative; */
  float: left;
  margin-top: 5px;
  margin-left: 10px;
  letter-spacing: 5px;
}

.header-right {
  float: right;
  padding-right: 10px;
}

.header-user-con {
  display: flex;
  height: 60px;
  align-items: center;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-top: -15px;
  margin-left: 10px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}

.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}

.btn-bell .el-icon-bell {
  color: #fff;
}

.user-name {
  margin-left: 10px;
}

.user-avator {
  margin-left: 20px;
}

.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}

.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}

.iconfontDrop {
  font-size: 14px;
}

.hqyzm {
  margin-top: -32px;
  margin-left: 9%;
  color: #ea2530;
}

.home_untreated {
  font-size: 14px;
  margin-right: 15px;
  color: white;
  cursor: pointer;
}

.home_skinBlue {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url(../../../../static/images/home/skin_blue.png), no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.home_skinRed {
  display: inline-block;
  width: 25px;
  height: 25px;
  background: url(../../../../static/images/home/skin_red.png), no-repeat;
  background-size: 100% 100%;
  cursor: pointer;
}

.untreated_bg {
  display: inline-block;
  width: 8px;
  height: 5px;
  margin-bottom: 2px;
  background: url(../../../../static/images/home/head_more.png), no-repeat;
  background-size: 100% 100%;
}
.untreatedNum {
  display: inline-block;
  height: 15px;
  width: 15px;
  background-color: #ed1c24;
  position: absolute;
  top: 8px;
  left: 50px;
  border-radius: 50px;
  color: white;
  font-size: 10px;
  line-height: 15px;
  text-align: center;
}
.untreated_style {
  color: #135381;
}
.department {
  font-size: 14px;
  margin-right: 5px;
}
.home_topIcons {
  margin-right: 15px;
  overflow: hidden;
  cursor: pointer;
}
.home_topIcon {
  float: left;
  width: 100%;
  height: 100%;
  color: white;
  /* margin-right: 15px; */
}
.iconzelvxuanzefeiyongdaosanjiaoxingfandui:before {
  content: none;
}
.changeSkin{
  padding-left: 10px;
  font-size: 12px;
  cursor:default;
}
.header-title {
  float: left;
  margin-left: -50px;
  font-size: 30px;
  line-height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/views/common/layout/HeadDom.vue